import { render } from "./EditParagraphModal.vue?vue&type=template&id=58742041&scoped=true&ts=true"
import script from "./EditParagraphModal.vue?vue&type=script&lang=ts"
export * from "./EditParagraphModal.vue?vue&type=script&lang=ts"

import "./EditParagraphModal.vue?vue&type=style&index=0&id=58742041&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58742041"]])

export default __exports__